import { Paths } from 'src/constants/paths'

export const getEmailDocuSignReturnUrl = () => {
  return [import.meta.env.VITE_WEB_DOMAIN, Paths.CompleteDocuSignAction].join(
    '',
  )
}
